module.exports = __webpack_public_path__ + "img/ctrl-ising-stub-down-1.9a773fcd.svg";